var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceRecognitionBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 582 533",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(453,111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "453 111; 453 111; 493 71; 493 71; 453 111; 453 111",
    keyTimes: "0; 0.04; 0.086667; 0.66; 0.713333; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0 0 1 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.04; 0.086667; 0.66; 0.713333; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.1 1.1; 1.1 1.1; 1 1; 1 1",
    keyTimes: "0; 0.04; 0.086667; 0.66; 0.713333; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i0",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    stroke: "#3490dc",
    d: "M-11.5,-11.5C-11.5,-11.5,11.5,-11.5,11.5,-11.5C11.5,-11.5,11.5,11.5,11.5,11.5"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.1,111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "124.1 111; 124.1 111; 84.1 71; 84.1 71; 124.1 111; 124.1 111",
    keyTimes: "0; 0.03; 0.063333; 0.633334; 0.7; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0 0 1 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.03; 0.063333; 0.633334; 0.7; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.1 1.1; 1.1 1.1; 1 1; 1 1",
    keyTimes: "0; 0.03; 0.063333; 0.633334; 0.7; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i0",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    stroke: "#3490dc",
    d: "M-34.5,11.5C-34.5,11.5,-34.5,-11.5,-34.5,-11.5C-34.5,-11.5,-11.5,-11.5,-11.5,-11.5"
  }))))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132,426)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "132 426; 132 426; 92 466; 92 466; 132 426; 132 426",
    keyTimes: "0; 0.023333; 0.093333; 0.62; 0.69; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0 0 1 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.023333; 0.093333; 0.62; 0.69; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.1 1.1; 1.1 1.1; 1 1; 1 1",
    keyTimes: "0; 0.023333; 0.093333; 0.62; 0.69; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i0",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    stroke: "#3490dc",
    d: "M11.5,11.5C11.5,11.5,-11.5,11.5,-11.5,11.5C-11.5,11.5,-11.5,-11.5,-11.5,-11.5"
  }))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(453,426)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "453 426; 453 426; 493 466; 493 466; 453 426; 453 426",
    keyTimes: "0; 0.003333; 0.073333; 0.596666; 0.66; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0 0 1 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.003333; 0.073333; 0.596666; 0.66; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1.1 1.1; 1.1 1.1; 1 1; 1 1",
    keyTimes: "0; 0.003333; 0.073333; 0.596666; 0.66; 1",
    keySplines: "0 0 1 1; 0.82 0 0.84 1; 0.82 0 0.84 1; 0.167 0 0.84 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i0",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    stroke: "#3490dc",
    d: "M11.5,-11.5C11.5,-11.5,11.5,11.5,11.5,11.5C11.5,11.5,-11.5,11.5,-11.5,11.5"
  }))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,238.499,270.001)",
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3490dc",
    fillRule: "evenodd",
    d: "M-4.069,8.083C-3.01,7.769,-1.897,8.371,-1.583,9.43C-1.062,11.184,-0.621,11.968,-0.103,12.892C-0.103,12.892,-0.103,12.893,-0.103,12.893C0.014,13.101,0.134,13.317,0.261,13.552C3.606,19.764,9.407,25.579,10.414,26.586C11.237,27.409,12.553,28.29,13.395,28.711C13.64,28.833,14.293,29.044,15.244,29.222C16.15,29.392,17.149,29.5,18,29.5C19.105,29.5,20,30.395,20,31.5C20,32.605,19.105,33.5,18,33.5C16.851,33.5,15.601,33.358,14.507,33.153C13.458,32.956,12.361,32.667,11.606,32.289C10.449,31.71,8.763,30.591,7.586,29.414C7.586,29.414,7.573,29.401,7.573,29.401C7.151,28.979,5.874,27.701,4.262,25.877C4.262,25.877,3.496,38.125,3.496,38.125C3.496,38.125,3.429,39.208,3.429,39.208C3.429,39.208,2.483,39.742,2.483,39.742C2.483,39.742,-17.017,50.742,-17.017,50.742C-17.979,51.285,-19.199,50.945,-19.742,49.983C-20.285,49.021,-19.944,47.801,-18.982,47.258C-18.982,47.258,-0.428,36.791,-0.428,36.791C-0.428,36.791,0.504,21.875,0.504,21.875C0.515,21.706,0.546,21.543,0.595,21.389C-0.781,19.553,-2.14,17.529,-3.261,15.448C-3.362,15.261,-3.466,15.075,-3.575,14.882C-4.123,13.909,-4.763,12.77,-5.417,10.569C-5.731,9.51,-5.128,8.398,-4.069,8.083ZM-7.686,-10.991C-6.586,-11.094,-5.612,-10.286,-5.509,-9.186C-5.509,-9.186,-5.491,-9.004,-5.491,-9.004C-5.401,-8.038,-5.362,-7.615,-5.308,-7.194C-5.266,-6.866,-5.214,-6.539,-5.124,-5.958C-5.095,-5.77,-5.062,-5.555,-5.023,-5.305C-4.854,-4.213,-5.603,-3.192,-6.695,-3.024C-7.787,-2.856,-8.808,-3.603,-8.976,-4.695C-9.011,-4.925,-9.043,-5.126,-9.071,-5.306C-9.17,-5.945,-9.227,-6.311,-9.274,-6.678C-9.337,-7.166,-9.383,-7.657,-9.49,-8.801C-9.49,-8.801,-9.491,-8.814,-9.491,-8.814C-9.594,-9.914,-8.786,-10.888,-7.686,-10.991ZM-7.289,-34.395C-0.042,-48.889,12.02,-51,17.5,-51C18.605,-51,19.5,-50.105,19.5,-49C19.5,-47.895,18.605,-47,17.5,-47C12.98,-47,2.642,-45.312,-3.711,-32.606C-4.775,-30.478,-5.278,-27.668,-5.466,-24.386C-5.529,-23.283,-6.474,-22.44,-7.577,-22.503C-8.68,-22.566,-9.522,-23.511,-9.459,-24.614C-9.261,-28.078,-8.718,-31.537,-7.289,-34.395Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,349.501,270.001)",
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3490dc",
    fillRule: "evenodd",
    d: "M-4.069,8.083C-3.01,7.769,-1.897,8.371,-1.583,9.43C-1.062,11.184,-0.621,11.968,-0.103,12.892C-0.103,12.892,-0.103,12.893,-0.103,12.893C0.014,13.101,0.134,13.317,0.261,13.552C3.606,19.764,9.407,25.579,10.414,26.586C11.237,27.409,12.553,28.29,13.395,28.711C13.64,28.833,14.293,29.044,15.244,29.222C16.15,29.392,17.149,29.5,18,29.5C19.105,29.5,20,30.395,20,31.5C20,32.605,19.105,33.5,18,33.5C16.851,33.5,15.601,33.358,14.507,33.153C13.458,32.956,12.361,32.667,11.606,32.289C10.449,31.71,8.763,30.591,7.586,29.414C7.586,29.414,7.573,29.401,7.573,29.401C7.151,28.979,5.874,27.701,4.262,25.877C4.262,25.877,3.496,38.125,3.496,38.125C3.496,38.125,3.429,39.208,3.429,39.208C3.429,39.208,2.483,39.742,2.483,39.742C2.483,39.742,-17.017,50.742,-17.017,50.742C-17.979,51.285,-19.199,50.945,-19.742,49.983C-20.285,49.021,-19.944,47.801,-18.982,47.258C-18.982,47.258,-0.428,36.791,-0.428,36.791C-0.428,36.791,0.504,21.875,0.504,21.875C0.515,21.706,0.546,21.543,0.595,21.389C-0.781,19.553,-2.14,17.529,-3.261,15.448C-3.362,15.261,-3.466,15.075,-3.575,14.882C-4.123,13.909,-4.763,12.77,-5.417,10.569C-5.731,9.51,-5.128,8.398,-4.069,8.083ZM-7.686,-10.991C-6.586,-11.094,-5.612,-10.286,-5.509,-9.186C-5.509,-9.186,-5.491,-9.004,-5.491,-9.004C-5.401,-8.038,-5.362,-7.615,-5.308,-7.194C-5.266,-6.866,-5.214,-6.539,-5.124,-5.958C-5.095,-5.77,-5.062,-5.555,-5.023,-5.305C-4.854,-4.213,-5.603,-3.192,-6.695,-3.024C-7.787,-2.856,-8.808,-3.603,-8.976,-4.695C-9.011,-4.925,-9.043,-5.126,-9.071,-5.306C-9.17,-5.945,-9.227,-6.311,-9.274,-6.678C-9.337,-7.166,-9.383,-7.657,-9.49,-8.801C-9.49,-8.801,-9.491,-8.814,-9.491,-8.814C-9.594,-9.914,-8.786,-10.888,-7.686,-10.991ZM-7.289,-34.395C-0.042,-48.889,12.02,-51,17.5,-51C18.605,-51,19.5,-50.105,19.5,-49C19.5,-47.895,18.605,-47,17.5,-47C12.98,-47,2.642,-45.312,-3.711,-32.606C-4.775,-30.478,-5.278,-27.668,-5.466,-24.386C-5.529,-23.283,-6.474,-22.44,-7.577,-22.503C-8.68,-22.566,-9.522,-23.511,-9.459,-24.614C-9.261,-28.078,-8.718,-31.537,-7.289,-34.395Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.036667; 0.126667; 0.13; 0.55; 0.553334; 0.64; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.5,169.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "268.5 169.5; 268.5 169.5; 324.5 475.5; 324.5 475.5; 324.5 475.5; 324.5 475.5; 268.5 169.5; 268.5 169.5",
    keyTimes: "0; 0.036667; 0.126666; 0.13; 0.55; 0.553334; 0.64; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.036667; 0.126666; 0.13; 0.55; 0.553334; 0.64; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.036667; 0.126666; 0.13; 0.55; 0.553334; 0.64; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.006667; 0.083333; 0.086667; 0.586667; 0.59; 0.676667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.5,169.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "319.5 169.5; 319.5 169.5; 259 475.5; 259 475.5; 259 475.5; 259 475.5; 319.5 169.5; 319.5 169.5",
    keyTimes: "0; 0.006667; 0.083333; 0.086667; 0.586667; 0.59; 0.676667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.006667; 0.083333; 0.086667; 0.586667; 0.59; 0.676667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.006667; 0.083333; 0.086667; 0.586667; 0.59; 0.676667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.023333; 0.076667; 0.08; 0.64; 0.643333; 0.73; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.5,223.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "268.5 223.5; 268.5 223.5; 324 476; 324 476; 324 476; 324 476; 268.5 223.5; 268.5 223.5",
    keyTimes: "0; 0.023333; 0.076667; 0.08; 0.64; 0.643333; 0.73; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.023333; 0.076667; 0.08; 0.64; 0.643333; 0.73; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.023333; 0.076667; 0.08; 0.64; 0.643333; 0.73; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.06; 0.1; 0.103333; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.5,220.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "214.5 220.5; 214.5 220.5; 324.5 475; 324.5 475; 324.5 475; 324.5 475; 214.5 220.5; 214.5 220.5",
    keyTimes: "0; 0.06; 0.1; 0.103333; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.06; 0.1; 0.103333; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.06; 0.1; 0.103333; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.043333; 0.093333; 0.096666; 0.58; 0.583333; 0.67; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.5,277.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "220.5 277.5; 220.5 277.5; 291 475; 291 475; 291 475; 291 475; 220.5 277.5; 220.5 277.5",
    keyTimes: "0; 0.043333; 0.093333; 0.096666; 0.58; 0.583333; 0.67; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.043333; 0.093333; 0.096666; 0.58; 0.583333; 0.67; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.043333; 0.093333; 0.096666; 0.58; 0.583333; 0.67; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.066667; 0.12; 0.123333; 0.56; 0.563334; 0.65; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370.5,220.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "370.5 220.5; 370.5 220.5; 292 475; 292 475; 292 475; 292 475; 370.5 220.5; 370.5 220.5",
    keyTimes: "0; 0.066667; 0.12; 0.123333; 0.56; 0.563334; 0.65; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.066667; 0.12; 0.123333; 0.56; 0.563334; 0.65; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.066667; 0.12; 0.123333; 0.56; 0.563334; 0.65; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.053333; 0.113334; 0.116667; 0.573333; 0.576666; 0.663333; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.5,277.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "361.5 277.5; 361.5 277.5; 292 475; 292 475; 292 475; 292 475; 361.5 277.5; 361.5 277.5",
    keyTimes: "0; 0.053333; 0.113334; 0.116667; 0.573333; 0.576666; 0.663333; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.053333; 0.113334; 0.116667; 0.573333; 0.576666; 0.663333; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.053333; 0.113334; 0.116667; 0.573333; 0.576666; 0.663333; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.016667; 0.073333; 0.076666; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.5,223.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "319.5 223.5; 319.5 223.5; 292 475; 292 475; 292 475; 292 475; 319.5 223.5; 319.5 223.5",
    keyTimes: "0; 0.016667; 0.073333; 0.076666; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.016667; 0.073333; 0.076666; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.016667; 0.073333; 0.076666; 0.606667; 0.61; 0.696667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.08; 0.083333; 0.58; 0.583333; 0.67; 1",
    keySplines: "0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.5,265.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "268.5 265.5; 325.5 475.5; 325.5 475.5; 325.5 475.5; 325.5 475.5; 268.5 265.5; 268.5 265.5",
    keyTimes: "0; 0.08; 0.083333; 0.58; 0.583333; 0.67; 1",
    keySplines: "0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.08; 0.083333; 0.58; 0.583333; 0.67; 1",
    keySplines: "0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.08; 0.083333; 0.58; 0.583333; 0.67; 1",
    keySplines: "0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.006667; 0.056667; 0.06; 0.546667; 0.55; 0.636667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.5,265.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "319.5 265.5; 319.5 265.5; 292 475.5; 292 475.5; 292 475.5; 292 475.5; 319.5 265.5; 319.5 265.5",
    keyTimes: "0; 0.006667; 0.056667; 0.06; 0.546667; 0.55; 0.636667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.006667; 0.056667; 0.06; 0.546667; 0.55; 0.636667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.006667; 0.056667; 0.06; 0.546667; 0.55; 0.636667; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0.4; 0.4; 0.4; 0; 0.4; 0.4; 0.4; 0.4",
    keyTimes: "0; 0.023333; 0.083333; 0.086667; 0.52; 0.523333; 0.61; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(292.5,307.5)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "292.5 307.5; 292.5 307.5; 259 475; 259 475; 259 475; 259 475; 292.5 307.5; 292.5 307.5",
    keyTimes: "0; 0.023333; 0.083334; 0.086667; 0.52; 0.523334; 0.61; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 0; 0; 0; 0; 0; 0",
    keyTimes: "0; 0.023333; 0.083334; 0.086667; 0.52; 0.523334; 0.61; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1; 1 1",
    keyTimes: "0; 0.023333; 0.083334; 0.086667; 0.52; 0.523334; 0.61; 1",
    keySplines: "0 0 1 1; 0.97 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0.97 0 0.14 1; 0.167 0 0.14 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "visible",
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.543; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1; 0.5; 0.3; 1; 1; 0.3; 1; 1; 1; 0; 0",
    keyTimes: "0; 0.08; 0.166667; 0.22; 0.273333; 0.28; 0.333333; 0.386667; 0.44; 0.496666; 0.55; 0.553333; 0.566667; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.5,475.5) scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "visible",
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.543; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.034; 0.07; 0.105; 0.141; 0.177; 0.214; 0.25; 0.286; 0.322; 0.358; 0.394; 0.43; 0.466; 0.502; 0.537; 0.572; 0.607; 0.642; 0.676; 0.71; 0.744; 0.777; 0.81; 0.842; 0.873; 0.903; 0.931; 0.958; 0.982; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 0.977; 0.953; 0.93; 0.907; 0.883; 0.86; 0.837; 0.813; 0.79; 0.767; 0.743; 0.72; 0.697; 0.673; 0.65; 0.627; 0.603; 0.58; 0.557; 0.533; 0.51; 0.487; 0.463; 0.44; 0.417; 0.393; 0.37; 0.347; 0.323; 0.3; 0.323; 0.347; 0.37; 0.393; 0.417; 0.44; 0.463; 0.487; 0.51; 0.533; 0.557; 0.58; 0.603; 0.627; 0.65; 0.673; 0.697; 0.72; 0.743; 0.767; 0.79; 0.813; 0.837; 0.86; 0.883; 0.907; 0.93; 0.953; 0.977; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 0.977; 0.953; 0.93; 0.907; 0.883; 0.86; 0.837; 0.813; 0.79; 0.767; 0.743; 0.72; 0.697; 0.673; 0.65; 0.627; 0.603; 0.58; 0.557; 0.533; 0.51; 0.487; 0.463; 0.44; 0.417; 0.393; 0.37; 0.347; 0.323; 0.3; 0.323; 0.347; 0.37; 0.393; 0.417; 0.44; 0.463; 0.487; 0.51; 0.533; 0.557; 0.58; 0.603; 0.627; 0.65; 0.673; 0.697; 0.72; 0.743; 0.767; 0.79; 0.813; 0.837; 0.86; 0.883; 0.907; 0.93; 0.953; 0.977; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 0.967; 0.933; 0.9; 0.867; 0.833; 0.8; 0.767; 0.733; 0.7; 0.667; 0.633; 0.6; 0.567; 0.533; 0.5; 0.467; 0.433; 0.4; 0.367; 0.333; 0.3; 0.267; 0.233; 0.2; 0.167; 0.133; 0.1; 0.067; 0.033; 0; 0.017; 0.033; 0.05; 0.067; 0.083; 0.1; 0.117; 0.133; 0.15; 0.167; 0.183; 0.2; 0.217; 0.233; 0.25; 0.267; 0.283; 0.3; 0.317; 0.333; 0.35; 0.367; 0.383; 0.4; 0.417; 0.433; 0.45; 0.467; 0.483; 0.5; 0.517; 0.533; 0.55; 0.567; 0.583; 0.6; 0.617; 0.633; 0.65; 0.667; 0.683; 0.7; 0.717; 0.733; 0.75; 0.767; 0.783; 0.8; 0.817; 0.833; 0.85; 0.867; 0.883; 0.9; 0.917; 0.933; 0.95; 0.967; 0.983; 1; 1",
    keyTimes: "0; 0.076667; 0.077889; 0.079111; 0.080334; 0.081555; 0.082778; 0.084; 0.085222; 0.086445; 0.087667; 0.088889; 0.090111; 0.091333; 0.092556; 0.093778; 0.095; 0.096222; 0.097444; 0.098667; 0.099889; 0.101111; 0.102333; 0.103556; 0.104778; 0.106; 0.107222; 0.108444; 0.109667; 0.110889; 0.112111; 0.113334; 0.115111; 0.116889; 0.118667; 0.120444; 0.122222; 0.124; 0.125778; 0.127556; 0.129333; 0.131111; 0.132889; 0.134667; 0.136444; 0.138222; 0.14; 0.141778; 0.143556; 0.145333; 0.147111; 0.148889; 0.150667; 0.152445; 0.154222; 0.156; 0.157778; 0.159555; 0.161333; 0.163111; 0.164889; 0.166667; 0.168444; 0.170222; 0.172; 0.173778; 0.175555; 0.177334; 0.179111; 0.180889; 0.182667; 0.184444; 0.186222; 0.188; 0.189778; 0.191556; 0.193333; 0.195111; 0.196889; 0.198667; 0.200444; 0.202222; 0.204; 0.205778; 0.207556; 0.209333; 0.211111; 0.212889; 0.214666; 0.216445; 0.218222; 0.22; 0.222; 0.224; 0.226; 0.228; 0.23; 0.232; 0.234; 0.236; 0.238; 0.24; 0.242; 0.244; 0.246; 0.248; 0.25; 0.252; 0.254; 0.256; 0.258; 0.26; 0.262; 0.264; 0.266; 0.268; 0.27; 0.272; 0.274; 0.276; 0.278; 0.28; 0.281778; 0.283556; 0.285333; 0.287111; 0.288889; 0.290666; 0.292444; 0.294222; 0.296; 0.297778; 0.299556; 0.301333; 0.303111; 0.304889; 0.306667; 0.308445; 0.310222; 0.312; 0.313778; 0.315555; 0.317333; 0.319111; 0.320889; 0.322667; 0.324444; 0.326222; 0.328; 0.329778; 0.331556; 0.333334; 0.335111; 0.336889; 0.338667; 0.340444; 0.342222; 0.344; 0.345778; 0.347556; 0.349333; 0.351111; 0.352889; 0.354667; 0.356444; 0.358222; 0.36; 0.361778; 0.363556; 0.365333; 0.367111; 0.368889; 0.370667; 0.372445; 0.374222; 0.376; 0.377778; 0.379555; 0.381333; 0.383111; 0.384889; 0.386667; 0.388555; 0.390444; 0.392333; 0.394222; 0.396111; 0.398; 0.399889; 0.401778; 0.403667; 0.405555; 0.407445; 0.409334; 0.411222; 0.413111; 0.415; 0.416889; 0.418778; 0.420666; 0.422556; 0.424445; 0.426333; 0.428222; 0.430111; 0.432; 0.433889; 0.435778; 0.437667; 0.439556; 0.441444; 0.443333; 0.445111; 0.446889; 0.448667; 0.450445; 0.452222; 0.454; 0.455778; 0.457555; 0.459333; 0.461111; 0.462889; 0.464667; 0.466444; 0.468222; 0.47; 0.471778; 0.473555; 0.475334; 0.477111; 0.478889; 0.480667; 0.482444; 0.484222; 0.486; 0.487778; 0.489556; 0.491333; 0.493111; 0.494889; 0.496667; 0.498333; 0.5; 0.501667; 0.503333; 0.505; 0.506667; 0.508334; 0.51; 0.511667; 0.513334; 0.515; 0.516667; 0.518333; 0.52; 0.521667; 0.523333; 0.525; 0.526667; 0.528333; 0.53; 0.531666; 0.533333; 0.535; 0.536666; 0.538333; 0.54; 0.541667; 0.543333; 0.545; 0.546667; 0.546778; 0.546889; 0.547; 0.547111; 0.547222; 0.547333; 0.547445; 0.547555; 0.547667; 0.547778; 0.547889; 0.548; 0.548111; 0.548222; 0.548333; 0.548444; 0.548556; 0.548667; 0.548778; 0.548889; 0.549; 0.549111; 0.549222; 0.549333; 0.549445; 0.549555; 0.549667; 0.549778; 0.549889; 0.55; 0.550778; 0.551555; 0.552333; 0.553111; 0.553889; 0.554667; 0.555444; 0.556222; 0.557; 0.557778; 0.558556; 0.559333; 0.560111; 0.560889; 0.561667; 0.562444; 0.563222; 0.564; 0.564778; 0.565556; 0.566333; 0.567111; 0.567889; 0.568667; 0.569444; 0.570222; 0.571; 0.571778; 0.572556; 0.573333; 1",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.5,475.5) scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "visible",
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.543; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1; 0.3; 1; 1; 0.3; 1; 1; 0.3; 0; 1; 1",
    keyTimes: "0; 0.056667; 0.06; 0.113333; 0.166667; 0.226667; 0.28; 0.333333; 0.39; 0.443333; 0.496667; 0.543333; 0.553333; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(292.5,475.5) scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#3490dc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceRecognitionBlue);
export default __webpack_public_path__ + "static/media/face_recognition_blue.7e5b28ac351d5db63fdcee98d16541d5.svg";
export { ForwardRef as ReactComponent };